import React from "react";
import { Typography } from "Components/Base/DataDisplay/Typography";
import { Checkbox } from "Components/Base/Inputs/Checkbox";
import { Box } from "Components/Base/Layout/Box";
import { MetadataRequiredMark } from "lib/components/ItemMetadataFields/fields/shared";

const boolToApi = (checked) => (checked ? "1" : "0");

const apiToBool = (value) => value === "1" || value === true || value === 1;

const BoolField = ({ field, fieldState, disabled, onChange }) => {
  const { fieldError, fieldId, labelText, required, value } = fieldState;

  return (
    <Box mb={1.25}>
      <Checkbox
        id={fieldId}
        checked={apiToBool(value)}
        disabled={disabled}
        onChange={(event) =>
          onChange(field.id, boolToApi(event.target.checked))
        }
        label={
          <>
            {labelText}
            {required ? <MetadataRequiredMark /> : null}
          </>
        }
        ariaLabel={labelText}
      />
      {fieldError ? (
        <Typography
          component="p"
          variant="body2"
          color="error"
          role="alert"
          sx={{ mt: 0.5 }}
        >
          {fieldError}
        </Typography>
      ) : null}
    </Box>
  );
};

export default BoolField;
